var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon-plus",attrs:{"src":require("assets/plus.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }